import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, CardVirtual } from 'medua-components';
import { history } from '../../../../store';

/* eslint-disable */
@translate('account')
export default class AccountBillingPayment extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };

    this.handleBack = this.handleBack.bind(this)
  }

  handleBack() {
    history.push('/account/billing')
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:billing.payment-information.title') }
        headerActionLeft={[
          { key: 1, icon: 'arrow-left', action: this.handleBack }
        ]}>
        <ListSection margin
          title={ this.props.t('account:billing.payment-information.method.title') } >
          <p className="text">{ this.props.t('account:billing.payment-information.method.info') + ' Credit Card' }</p>
          <CardVirtual
            small
            title="Mastercard"
            subtitle="**** **** ** 5897" />
        </ListSection>
        <ListSection padding
          title={ this.props.t('account:billing.payment-information.option.title') }>
          <div>{ this.props.t('account:billing.payment-information.option.casual') }</div>
          <div>{ this.props.t('account:billing.payment-information.option.paypal') }</div>
          <p className="text">{ this.props.t('account:billing.payment-information.option.info') }</p>
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/billing/payment/index.jsx